import { employerAccountingApiV1 } from "./client";

export const clearCurrentUserCart = async(): Promise<void> => {
  await employerAccountingApiV1.cart.clearCart();
};